@if (isAllowed) { @if (loading) {
<ecp-loader></ecp-loader>
}
<ng-content></ng-content>
}
